import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';

export const isFederatedResultsEnabled = (): boolean =>
	expVal<boolean>('fed_search_results_in_conf_fps', 'isEnabled', false);

/** Query setup already records exposure; analytics must not expose the user again. */
export const getFederatedResultsExperimentValueWithoutExposure = (): boolean =>
	UNSAFE_expValNoExposure<boolean>('fed_search_results_in_conf_fps', 'isEnabled', false);
